import React, { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../loginSlice";
import { fetchThemeData } from "../../admin/themeSlice";
import "./login.css";
import { setBackButtonUrl } from "../uiSlice";
import Swal from "sweetalert2";

function Login() {
  const dispatch = useDispatch();
  const { status, user, error } = useSelector((state) => state.auth);
  const { status: themeStatus, data: themeData, error: themeError } = useSelector(
    (state) => state.theme
  );

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isAdmin = searchParams.get("admin") === "true";

  useEffect(() => {
    dispatch(loginUser());
  }, [dispatch]);

  useEffect(() => {
    if (status === "succeeded" && user && isAdmin) {
      navigate("/admin");
    }
  }, [status, user, isAdmin, navigate]);

  useEffect(() => {
    console.log("user",user);
    if (status === "succeeded" && user.backButtonRedirect) {
      dispatch(setBackButtonUrl(user.backButtonRedirect));
    }

  }, [status, user]);



 useEffect(() => {
  if (status !== "failed") return;
  const msg = error ? String(error) : "Session expired";
  const redirect = user && user.backButtonRedirect ? user.backButtonRedirect : "/";
  Swal.fire("Session Expired!", msg, "error").then(() => {
    window.location.href = redirect;
  });
}, [status, error, user]);

// show "already played" modal when lambda gameover > 0
useEffect(() => {
  if (isAdmin) return;
  if (status !== "succeeded" || !user) return;
  // isMultiplaySession lets the user replay, so skip the "already played" block.
  if (user.isMultiplaySession) return;
  if (Number(user.gameover) > 0) {
    const redirect = user.backButtonRedirect || "/";
    Swal.fire("You have already played!", "  ", "error").then(() => {
      window.location.href = redirect;
    });
  }
}, [status, user, isAdmin]);

  // BEGIN PLAY must stay hidden until BOTH the login thunk (which itself
  // awaits the org lookup + gameover check before resolving) and the theme
  // fetch have fully settled. Checking "not loading" alone isn't enough --
  // idle counts as not-loading too, so a fresh mount would otherwise flash
  // the button before either request has even started.
  const authSettled = status === "succeeded" || status === "failed";
  const themeSettled = themeStatus === "succeeded" || themeStatus === "failed";
  const showLoginLoader = !authSettled || !themeSettled;

  if (showLoginLoader) {
    return (
      <div className="login-main-container">
        <div className="login-loader-container">
          <div className="login-loader"></div>
        </div>
      </div>
    );
  }

  // Theme fetch settled but failed -- showing BEGIN PLAY here would send the
  // player into /rules with no theme data, where they'd be stuck on that
  // page's own loader forever (it waits on themeData before revealing
  // anything). Offer a retry instead of a dead-end button.
  if (themeStatus === "failed") {
    return (
      <div className="login-main-container">
        <p className="login-theme-error">
          Couldn't load this game: {themeError || "unknown error"}
        </p>
        <button
          className="begin-play-btn login-retry-btn"
          onClick={() => dispatch(fetchThemeData({ themeId: null }))}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="login-main-container">
      {themeData && (
        <img
          src={process.env.REACT_APP_S3_PATH + themeData.logo}
          className="login-logo"
          alt="Game Logo"
        />
      )}
        {user && status === "succeeded" && themeStatus === "succeeded" && (
          <div>
            <Link to="/rules" className="begin-play-btn">
              BEGIN PLAY
            </Link>
          </div>
        )}
    </div>
  );
}

export default Login;
